import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';

import { arrowRightIcon } from '../../../../icons';
import { IBooking } from '../../../models/book-workshop.models';

@Component({
    selector: 'app-book-workshop-user-info',
    template: `
        <section class="flow-step__header">
            <h1 class="h4">{{ 'book_workshop.contact_information' | translate }}</h1>
            <div>{{ 'book_workshop.fill_personal_information' | translate }}</div>
        </section>

        <ng-container [ngSwitch]="scrollready">
            <div class="loader" *ngSwitchCase="false"></div>

            <form class="book-workshop-stepper-content__form book-workshop-user-info-form"
                *ngSwitchCase="true"
                [formGroup]="form"
                (ngSubmit)="onSubmit()">
                <app-user-info-inputs [parentForm]="form"></app-user-info-inputs>
                <div class="input-light-theme">
                    <app-personal-information-consent controlName="consent" [parentForm]="form"></app-personal-information-consent>
                    <app-book-workshop-terms-n-conditions controlName="terms" [parentForm]="form"></app-book-workshop-terms-n-conditions>
                </div>
                <div class="book-workshop-flow__bottom">
                    <div class="book-workshop-flow__bottom-content">
                        <app-button
                            buttonClass="book-workshop-stepper-content__continue-button button--tertiary"
                            (click)="previousStepClick()"
                            [title]="'book_workshop.back' | translate"
                        ></app-button>
                        <app-button
                            buttonClass="book-workshop-stepper-content__continue-button button--primary"
                            buttonType="submit"
                            [title]="'book_workshop.continue' | translate"
                        >
                            <i class="button__icon">${arrowRightIcon}</i>
                        </app-button>
                    </div>
                </div>
            </form>
        </ng-container>

    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookWorkshopUserInfoComponent implements OnInit {
    @Input() booking: IBooking | null;
    @Output() nextStep = new EventEmitter();
    @Output() previousStep = new EventEmitter();

    form = this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        email: ['', Validators.compose([Validators.required, Validators.email])],
        phone: ['', Validators.required],
        address: ['', Validators.required],
        zipCode: ['', Validators.required],
        city: ['', Validators.required],
        consent: [false],
        terms: [false, { validators: [Validators.requiredTrue], updateOn: 'change' }], // Safari fix: Set updateOn to change,
    });

    scrollready: boolean;

    constructor(
        private fb: UntypedFormBuilder,
        private cdr: ChangeDetectorRef
    ) {
        this.scrollready = false;
    }

    ngOnInit() {
        if (this.booking) {
            this.form.setValue({
                firstName: this.booking.firstName ?? '',
                lastName: this.booking.lastName ?? '',
                email: this.booking.email ?? '',
                phone: this.booking.phone ?? '',
                address: this.booking.address ?? '',
                zipCode: this.booking.zipCode ?? '',
                city: this.booking.city ?? '',
                consent: false,
                terms: false,
            });
        }

        setTimeout(() => {
            this.scrollready = true;
            this.cdr.markForCheck();
        }, 500);
    }

    previousStepClick() {
        if (this.booking && this.form.value) {
            this.previousStep.emit(this.form.value);
        } else {
            this.previousStep.emit();
        }

    }

    onSubmit() {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
        } else {
            this.nextStep.emit(this.form.value);
        }
    }
}
